/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

import VueGtag from 'vue-gtag'

// Vue.use(VueGtag, {
//   config: {id: ""},
//   appName: '',
//   pageTrackerScreenviewEnabled: true
// }, router);

export default VueGtag
